export enum EnumPagVencimentoTipo{
    FIXO = 0,
    INTERVALO = 1,
}